<template>
    <section class="inline large">
        <div class="grid center fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <div>
                <div class="text-center" v-if="isBuyer">
                    <h2 class="f3 text-bold">Step by step: buying a home with a top {{ glb.geo.city }} agent</h2>
                </div>
                <div class="text-center" v-else>
                    <h2 class="f3 text-bold">Step by step: selling your home</h2>
                </div>
            </div>
            <div>
                <ul class="tab static-tab tab-pills">
                    <li>
                        <a role="button" @click="switchBuyer(true)" :class="{active:isBuyer}" >Buyer</a>
                    </li>
                    <li>
                        <a role="button" @click="switchBuyer(false)" :class="{active:!isBuyer}">Seller</a>
                    </li>
                </ul>
            </div>
            <div class="agent-workflow-panel" v-if="isBuyer">
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i> Calculate payments</button>
                    <div>
                        <div><b> Discover your budget</b></div>
                        <div class="f7">Find out how much home you can afford</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i> Preapproval</button>
                    <div>
                        <div><b>Take the first financial step</b></div>
                        <div class="f7">See how much you can borrow</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i>Agent matching</button>
                    <div>
                        <div><b>Connect with a market expert</b></div>
                        <div class="f7">Get matched with a local buyer’s agent</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i>Submit an offer</button>
                    <div>
                        <div><b>Find a home that fits</b></div>
                        <div class="f7">Make an offer on the right home for you</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i> Close and move</button>
                    <div>
                        <div><b> Become a homeowner</b></div>
                        <div class="f7">Prepare for closing day and move</div>
                    </div>
                </div>
            </div>
            <div class="agent-workflow-panel" v-else>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i> Home valuation</button>
                    <div>
                        <div><b>Discover your home’s value</b></div>
                        <div class="f7">See what your home could sell for</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i> Agent matching</button>
                    <div>
                        <div><b>Connect with a market expert</b></div>
                        <div class="f7">Get matched with a local seller’s agent</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i>Listing preparation</button>
                    <div>
                        <div><b>Maximize your home sale</b></div>
                        <div class="f7">Ensure your home is showing ready</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i>Evaluate offers</button>
                    <div>
                        <div><b>Accept the offer that fits</b></div>
                        <div class="f7">Compare offers and contingencies</div>
                    </div>
                </div>
                <div>
                    <button class="btn small toggle"><i class="icon-check"></i>Closing</button>
                    <div>
                        <div><b> Complete repairs and close</b></div>
                        <div class="f7">Fix required items and plan to move</div>
                    </div>
                </div>
            </div>
            <button @click="openHotlead" class="btn primary regular width-fixed">Get Started with Movoto</button>
        </div>
    </section>
</template>
<script src="./agent-workflow.js"></script>
<style lang="scss">
@use "./agent-workflow.scss" as *;
</style>